import { DateTime } from "luxon"

import { getDataPointIntervals } from "@/features/datapoints/api/getDataPointIntervals.ts"
import type { DataPointValue } from "@/types/dataPointTypes.ts"

import type { FlowChartDataPoint } from "../../types/flowChartTypes.ts"

export const getFlowChartData = async (): Promise<FlowChartDataPoint[]> => {
  const startDate = DateTime.now().minus({ days: 1 }).toJSDate()
  const endDate = DateTime.now().minus({ seconds: 1 }).toJSDate()
  const interval = 1800
  const responses = await Promise.all([
    getDataPointIntervals(15, { start: startDate, end: endDate, interval, aggMode: "Average" }),
    getDataPointIntervals(12, { start: startDate, end: endDate, interval, aggMode: "Average" }),
    getDataPointIntervals(16, { start: startDate, end: endDate, interval, aggMode: "Average" }),
    getDataPointIntervals(13, { start: startDate, end: endDate, interval, aggMode: "Average" }),
  ])

  const [inlet, outlet, inletCH4, outletCH4]: DataPointValue[][] = responses

  return inlet.map((val, i) => ({
    timestamp: DateTime.fromISO(val.timestamp)
      .plus({ seconds: interval })
      .toLocaleString(DateTime.TIME_SIMPLE),
    inlet: (val.value || 0) / 1.44, // Flow rates are in MSCFD, must be divided by 1.44 to convert to SCFM
    methane: ((val.value || 0) / 1.44) * ((inletCH4[i]?.value || 0) / 100),
    outlet: ((outlet[i]?.value || 0) / 1.44) * ((outletCH4[i]?.value || 0) / 100),
  }))
}
